@if (is_loading) {
  <div class="spinner-body">
    <div class="spinner-wrapper">
      <div class="spinner-wrapper-loader">
        <p>Loading...</p>
        <div class="spinner-wrapper-circle">
          <div class="spinner-wrapper-circle-content">
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (!is_loading) {
  <div class="application-page">
    <div class="application-content" @fadeInOut>
      <div class="title">
        <h2 style="margin-bottom: 1rem;">Student details</h2>
        <h5 style="margin-bottom: 2rem;">Provide the details of the person studying</h5>
      </div>
      <form [formGroup]="studentForm">
        <div class="student-form">
          <div class="form-row">
            <label class="input-label">Student name</label>
            <input class="text-input"
              [ngClass]="{'text-input-error': validateFormControl('student_name', 'student')}"
              formControlName="student_name">
            @if (validateFormControl('student_name', 'student')) {
              <label class="error-message"
                >{{validationMessage('student_name',
              'student')}}</label>
            }
          </div>
          <div class="form-row">
            <label class="input-label">Student surname</label>
            <input class="text-input"
              [ngClass]="{'text-input-error': validateFormControl('student_surname', 'student')}"
              formControlName="student_surname">
            @if (validateFormControl('student_surname', 'student')) {
              <label class="error-message"
                >{{validationMessage('student_surname',
              'student')}}</label>
            }
          </div>
          <div class="form-row">
            <label class="input-label">Student ID number</label>
            <input class="text-input" type="tel" maxlength="13"
              [ngClass]="{'text-input-error': validateFormControl('student_id_number', 'student')}"
              formControlName="student_id_number" (keypress)="validateNumericInput($event)">
            @if (validateFormControl('student_id_number', 'student')) {
              <label class="error-message"
                >{{validationMessage('student_id_number',
              'student')}}</label>
            }
          </div>
          <div class="form-row">
            <label class="input-label">Student email</label>
            <input class="text-input"
              [ngClass]="{'text-input-error': validateFormControl('student_email', 'student')}"
              formControlName="student_email">
            @if (validateFormControl('student_email', 'student')) {
              <label class="error-message"
                >{{validationMessage('student_email',
              'student')}}</label>
            }
          </div>
          <div class="form-row">
            <label class="input-label">Student mobile number</label>
            <input class="text-input" type="tel" maxlength="10"
              [ngClass]="{'text-input-error': validateFormControl('student_contact_number', 'student')}"
              formControlName="student_contact_number" (keypress)="validateNumericInput($event)">
            @if (validateFormControl('student_contact_number', 'student')) {
              <label class="error-message"
                >{{validationMessage('student_contact_number',
              'student')}}</label>
            }
          </div>
          @if (is_ei_unique_link == false && !isRecommendedInstitution && !isEIGroup) {
            <div #educationalInstitution class="form-row"
              >
              <label class="input-label">Select educational institution</label>
              <input (focus)="scrollToInstitution()" matInput class="input-text-autocomplete" type="text"
                placeholder="Enter 3 or more characters" formControlName="educational_institution"
                maxlength="100" [matAutocomplete]="auto" [matAutocompletePosition]="'below'">
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="getEiName">
                @for (ei of filteredEIS | async; track ei) {
                  <mat-option [disabled]="ei.id === 0" [value]="ei">
                    {{ ei.name}}
                  </mat-option>
                }
                <button class="primary-button" (click)="recommendedInstitution()">Not finding your educational
                institution?</button>
              </mat-autocomplete>
              @if (validateFormControl('educational_institution', 'student')) {
                <label class="error-message">
                {{validationMessage('educational_institution','student')}}</label>
              }
            </div>
          }
          @if (isEIGroup) {
            <div #educationalInstitution class="form-row">
              <label class="input-label">Select educational institution</label>
              <input (focus)="scrollToInstitution()" matInput class="input-text-autocomplete" type="text"
                placeholder="Select educational institution" formControlName="educational_institution"
                [matAutocomplete]="auto" [matAutocompletePosition]="'below'">
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="getEiName">
                @for (ei of educationalInstitutions; track ei) {
                  <mat-option [disabled]="ei.id === 0" [value]="ei">
                    {{ ei.name}}
                  </mat-option>
                }
                <button class="primary-button" (click)="recommendedInstitution()">Not finding your educational
                institution?</button>
              </mat-autocomplete>
              @if (validateFormControl('educational_institution', 'student')) {
                <label class="error-message">
                {{validationMessage('educational_institution','student')}}</label>
              }
            </div>
          }
          @if (is_ei_unique_link == true) {
            <div class="form-row">
              <label class="input-label">Select educational institution</label>
              <input class="text-input" type="text"
                [value]="studentForm.get('educational_institution')?.value?.name" disabled>
            </div>
          }
          @if (isRecommendedInstitution && is_ei_unique_link == false) {
            <h5>Enter details of the educational
            institution</h5>
          }
          @if (isRecommendedInstitution && is_ei_unique_link == false) {
            <div class="form-row">
              <label class="input-label">Educational institution name</label>
              <input class="text-input"
                [ngClass]="{'text-input-error': validateFormControl('educational_institution_name', 'student')}"
                formControlName="educational_institution_name">
              @if (validateFormControl('educational_institution_name','student')) {
                <label class="error-message"
                >{{validationMessage('educational_institution_name','student')}}</label>
              }
            </div>
          }
          @if (isRecommendedInstitution) {
            <div class="form-row">
              <label class="input-label">Educational institution email </label>
              <input class="text-input"
                [ngClass]="{'text-input-error': validateFormControl('educational_institution_contact_email', 'student')}"
                formControlName="educational_institution_contact_email">
              @if (validateFormControl('educational_institution_contact_email','student')) {
                <label class="error-message"
                >{{validationMessage('educational_institution_contact_email','student')}}</label>
              }
            </div>
          }
          @if (isRecommendedInstitution) {
            <div class="form-row">
              <label class="input-label">Educational institution contact number</label>
              <input class="text-input" type="tel" maxlength="10" (keypress)="validateNumericInput($event)"
                [ngClass]="{'text-input-error': validateFormControl('educational_institution_contact_number', 'student')}"
                formControlName="educational_institution_contact_number">
              @if (validateFormControl('educational_institution_contact_number','student')) {
                <label class="error-message"
                >{{validationMessage('educational_institution_contact_number','student')}}</label>
              }
            </div>
          }
          @if (isRecommendedInstitution) {
            <div class="form-row">
              <label class="input-label">Educational institution website</label>
              <input class="text-input"
                [ngClass]="{'text-input-error': validateFormControl('educational_institution_website', 'student')}"
                formControlName="educational_institution_website">
              @if (validateFormControl('educational_institution_website','student')) {
                <label class="error-message"
                >{{validationMessage('educational_institution_website','student')}}</label>
              }
            </div>
          }
          <div class="form-row">
            <label class="input-label">Student or reference number (optional)</label>
            <input class="text-input"
              [ngClass]="{'text-input-error': validateFormControl('student_number', 'student')}"
              formControlName="student_number">
            @if (validateFormControl('student_number','student')) {
              <label class="error-message"
              >{{validationMessage('student_number','student')}}</label>
            }
          </div>
          <div class="form-row">
            <label class="input-label">Outstanding fees</label>
            <input currencyMask id="requested_amount" class="text-input"
              [ngClass]="{'text-input-error': validateFormControl('requested_amount', 'student')}"
              formControlName="requested_amount" (keypress)="validateNumericInput($event)">
            <labeL class="input-hint">Provide the fees as indicated on the quote or statement from the
            educational institution</labeL>
            @if (validateFormControl('requested_amount','student')) {
              <label class="error-message">
              {{validationMessage('requested_amount','student')}}</label>
            }
          </div>
          <div>
            <h5>Who will make the payment while the student studies?</h5>
            <mat-radio-group class="radio-group" (change)="paymentMadeByChanged($event)"
              formControlName="paymentMadeBy">
              <mat-radio-button [color]="'primary'" value="student"
              class="input-label">Student</mat-radio-button>
              <mat-radio-button [color]="'primary'" value="sponsor" class="input-label">Someone else
              (guarantor)</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </form>
      <form [formGroup]="sponsorForm">
        @if (showSponsorDetails) {
          <div class="sponsor-form">
            <h5>Provide the details of the guarantor</h5>
            <div class="form-row">
              <label class="input-label">Guarantor name</label>
              <input class="text-input"
                [ngClass]="{'text-input-error': validateFormControl('sponsor_name', 'sponsor')}"
                formControlName="sponsor_name">
              @if (validateFormControl('sponsor_name', 'sponsor')) {
                <label class="error-message"
                  >{{validationMessage('sponsor_name',
                'sponsor')}}</label>
              }
            </div>
            <div class="form-row">
              <label class="input-label">Guarantor surname</label>
              <input class="text-input"
                [ngClass]="{'text-input-error': validateFormControl('sponsor_surname', 'sponsor')}"
                formControlName="sponsor_surname">
              @if (validateFormControl('sponsor_surname', 'sponsor')) {
                <label class="error-message"
                  >{{validationMessage('sponsor_surname',
                'sponsor')}}</label>
              }
            </div>
            <div class="form-row">
              <label class="input-label">Guarantor SA ID number</label>
              <input class="text-input" type="tel" maxlength="13"
                [ngClass]="{'text-input-error': validateFormControl('sponsor_id_number', 'sponsor')}"
                formControlName="sponsor_id_number" (keypress)="validateNumericInput($event)">
              @if (validateFormControl('sponsor_id_number', 'sponsor')) {
                <label class="error-message"
                  >{{validationMessage('sponsor_id_number',
                'sponsor')}}</label>
              }
            </div>
            <div class="form-row">
              <label class="input-label">Guarantor email</label>
              <input class="text-input"
                [ngClass]="{'text-input-error': validateFormControl('sponsor_email', 'sponsor')}"
                formControlName="sponsor_email">
              @if (validateFormControl('sponsor_email', 'sponsor')) {
                <label class="error-message"
                  >{{validationMessage('sponsor_email',
                'sponsor')}}</label>
              }
            </div>
            <div class="form-row">
              <label class="input-label">Guarantor mobile number</label>
              <input class="text-input" type="tel" maxlength="10"
                [ngClass]="{'text-input-error': validateFormControl('sponsor_contact_number', 'sponsor')}"
                formControlName="sponsor_contact_number" (keypress)="validateNumericInput($event)">
              @if (validateFormControl('sponsor_contact_number', 'sponsor')) {
                <label class="error-message"
                  >{{validationMessage('sponsor_contact_number',
                'sponsor')}}</label>
              }
            </div>
          </div>
        }
      </form>
      @if (showQuestion) {
        <div style="margin-bottom: 2rem;">
          @if (!showSponsorDetails) {
            <h5>Does the person responsible for payment earn <br> R5 000 or more per month?
            </h5>
          }
          @if (showSponsorDetails) {
            <h5>Does the guarantor earn R5 000 or more per month?</h5>
          }
          <mat-radio-group class="radio-group" [(ngModel)]="isEarnMore">
            <mat-radio-button [color]="'primary'" value="yes" class="input-label">Yes</mat-radio-button>
            <mat-radio-button [color]="'primary'" value="no" class="input-label">No</mat-radio-button>
          </mat-radio-group>
        </div>
      }
      <div class="terms">
        <input id="consent" type="checkbox" [(ngModel)]="isTermsAccepted">
        <label [ngStyle]="{'border': markAsError ? '2px solid #e21d16' : null}" for="consent"></label>
        <p class="input-label">I agree to the <a href="/terms-and-conditions" target="_blank"
          rel="noopener noreferrer"><b><u>terms and conditions.</u></b></a></p>
          <!-- <p *ngIf="markAsError" class="error">*</p> -->
        </div>
        <div class="terms2">
          <input id="consent2" type="checkbox" [(ngModel)]="isTerms2Accepted">
          <label [ngStyle]="{'border': markAsError ? '2px solid #e21d16' : null}" for="consent2"></label>
          <p class="input-label">I consent that the parties may share my information between them to facilitate the
          processing of my application and the associated processes.</p>
          <!-- <p *ngIf="markAsError" class="error">*</p> -->
        </div>
        @if (showSponsorDetails) {
          <div class="form-row info-text">
            <p style="padding: 0 5px;">The next section needs to be completed by the guarantor.</p>
          </div>
        }
        @if (showSponsorDetails) {
          <h5 class="sponsor-modal-link" (click)="openSponsorDialog()">Guarantor not with you?
            <u>Click here</u>
          </h5>
        }
        <button class="primary-button" [disabled]="!formsValid() || !canClickNext || !isEarnMore" (click)="next()">
          Next
        </button>
      </div>
    </div>
  }